var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("label", { attrs: { for: _vm.handle } }, [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c(
        "v-select",
        {
          key: "fclr-" + _vm.handle + "-" + _vm.changeCounter,
          class: _vm.inputClass,
          attrs: {
            label: "label",
            options: _vm.options,
            disabled: _vm.disabled,
            placeholder: _vm.placeholder,
            multiple: _vm.multiple,
          },
          on: { input: _vm.change },
          model: {
            value: _vm.selectedValue,
            callback: function ($$v) {
              _vm.selectedValue = $$v
            },
            expression: "selectedValue",
          },
        },
        [
          _c("span", { attrs: { slot: "no-options" }, slot: "no-options" }, [
            _vm._v("Filteroptionen werden geladen..."),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "vs__open-indicator",
            attrs: { slot: "open-indicator" },
            slot: "open-indicator",
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }